import { render } from "./Arrears.vue?vue&type=template&id=6b326a3f"
import script from "./Arrears.vue?vue&type=script&lang=js"
export * from "./Arrears.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tansi\\OneDrive\\Desktop\\all\\quitrent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__